import React from 'react';
import { Icon, Button, makeStyles, colors } from '@material-ui/core';
import { Cake } from '@material-ui/icons';
import { Link, useLocation } from 'react-router-dom';

import Routes from 'config/routes';

const useStyles = makeStyles({
  link: {
    textDecoration: 'none',
  },
  button: {
    backgroundColor: colors.red[400],
    justifyContent: 'flex-start',
    color: colors.grey[50],
    padding: 8,
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
  icon: {
    marginTop: -4,
  },
});

const CreateRecipeButton = ({ fullWidth = false }) => {
  const classes = useStyles();
  const location = useLocation();

  return (
    <Link
      to={{
        pathname: Routes.createRecipe(),
        state: { from: location },
      }}
      className={classes.link}
    >
      <Button
        startIcon={
          <Icon className={classes.icon}>
            <Cake fontSize="small"></Cake>
          </Icon>
        }
        className={classes.button}
        fullWidth={fullWidth}
      >
        <b>CREATE RECIPE</b>
      </Button>
    </Link>
  );
};

export default CreateRecipeButton;
